import ym from 'react-yandex-metrika';
import {regionConfigValue} from "./regionConfigValue";

export const metricsID = {
  MSK: 71568595,
  REGION: 90856974,
  YANAO: 106868265,
}

export const metricsHost = {
  MSK: 'https://school.mos.ru',
  REGION: '',
  YANAO: 'https://school.yanao.ru',
}

export const metricsGoals = {
  WINDOW_SELECT_ROLE: 'windowSelectRole',
  SERVICES_SWITCH: 'servicesSwitch',
  ROLES_SWITCH: 'rolesSwitch',
}

export const YMInit = (user, rgn) => {
  const config = regionConfigValue();

  if (config?.SERVICE_URL === metricsHost.MSK) {

    /**
     * https://jira.mos.social/browse/ETD-7583
     */
    ym('setUserID', user.userId);

    ym('userParams', {
      sub: user.userId,
      role: user?.roles?.map(role => role.title).join(', ') || '',
      region: rgn,
      UserID: user.userId
    })
  }
}

export const reachGoal = (name, sub, nameServices, roles) => {
  const config = regionConfigValue();
  if (config?.SERVICE_URL === metricsHost.MSK) {
    ym('reachGoal', name, { sub, nameServices, role: roles?.map(role => role.title).join(', ') || '' })
  }
}

export const ymReachGoal = (name, data) => {
  const config = regionConfigValue();
  if (config?.SERVICE_URL === metricsHost.MSK) {
    if (data) {
      ym('reachGoal', name, data)
    } else {
      ym('reachGoal', name)
    }
  }
}
